import { render, staticRenderFns } from "./ModelImport.vue?vue&type=template&id=37e81399"
import script from "./ModelImport.vue?vue&type=script&lang=js"
export * from "./ModelImport.vue?vue&type=script&lang=js"
import style0 from "./ModelImport.vue?vue&type=style&index=0&id=37e81399&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports